export default {
  collectionAddress: 'Адрес коллекции',
  distributeStrategy: 'Стратегия распределения',
  amount: 'Сумма',
  chooseToken: 'Выберите токен',
  message: 'Текст сообщения',
  excludeOwnerCollection: 'Исключить коллекцию владельца',
  excludeNftSale: 'Исключить продажу NFT',
  address: 'Адрес',
  count: 'Количество',
  token: 'Токен',
  nftOwnerAddress: 'Адрес владельца NFT',
  datetime: 'Дата время',
  dateFrom: 'Дата С',
  dateTo: 'Дата По',
  accountId: 'ID аккаунта',
  distributeToken: 'Распределение токенов',
  search: 'Поиск',
  searchByName: 'Поиск по названию',
  type: 'Тип',
  transactionToken: 'Токен транзакции',
  explain: 'Пояснение',
  externalAccount: 'Внешний акканут',
  filters: 'Фильтры',
  owner: 'Владелец',
  inSale: 'В продаже',
  distribute: 'Распределение',
  view: 'Просмотр',
  result: 'Результат',
  save: 'Сохранить',
  selectToken: 'Выбрать токен',
  include: 'Включить',
  exclude: 'Исключить',
  send: 'Отправлено',
  receive: 'Получено',
};
